module.exports = __webpack_public_path__ + "14d90cf4777213efc7cd4607cbf91e.svg";